export default __webpack_public_path__ + "static/regular-cabin-living-4e304f9d2d7f669c683c4facbeab1215.jpg";